module.exports = __webpack_public_path__ + "static/media/Project2_Fig9.a8ae0cbf.png";